import React from 'react';
import { Container, Divider, Header } from 'semantic-ui-react';

const CommentsList = (props) => {
  
  const { comments } = props;

  return (
    <>
      {comments.length < 1 ? 
        <div>
          No comments have been recorded yet.
        </div> 
      :
        <>
          {comments.map((comment, index) => {
            return <Container className="mb-1">
              <Header size="tiny" className="mb-0_5">
                {comment.date} [{comment.user}]
                <Header.Subheader><b>{comment.egm}</b></Header.Subheader>
              </Header>
              {comment.comment}
              {index < comments.length - 1 && <Divider />}
            </Container>
          })}
        </>
      }
    </>
  )
}

export default CommentsList;